---
title: "Do Something Amateur Radio Club (DSARC) Constitution"
updated: 2024-01-01
adopted: 2024-01-01
---

# Do Something Amateur Radio Club (DSARC) Constitution

## Preamble
We, the members of the Do Something Amateur Radio Club (DSARC), unite to promote the art and science of amateur radio, foster community service through emergency communications, and provide an inclusive environment for education, STEM learning, and fellowship.  

---

## Article I: Name
The name of this organization shall be **Do Something Amateur Radio Club (DSARC)**.

---

## Article II: Purpose
The purpose of DSARC is to:
1. Encourage participation in amateur radio.
2. Provide training and resources for new and experienced operators.
3. Assist in emergency and public service communications.
4. Support STEM education and technical skill development.
5. Support the parent nonprofit, **Do Something Amateur Radio Club, Inc.**, and align with its mission.

---

## Article III: Membership

### Section 1: Rights and Privileges
Members of DSARC have the right to:
- Participate in all club activities and meetings.
- Vote on club matters (if they are voting members).
- Serve as club officers or committee chairs.

### Section 2: Responsibilities
Members are expected to:
- Pay annual dues.
- Abide by the bylaws and policies of DSARC and **Do Something Amateur Radio Club, Inc.**.
- Act in the best interest of the club and its mission.

---

## Article IV: Organization Structure

### Section 1: Authority
DSARC operates as a **program** under the authority of **Do Something Amateur Radio Club, Inc.** The DSARC, Inc. board retains oversight of all DSARC activities, finances, and governance to ensure alignment with the parent organization’s mission.

### Section 2: Leadership
DSARC leadership shall consist of a President, Vice-President, Secretary, and Treasurer, who are elected annually by voting members. All leadership decisions must comply with policies set by the DSARC, Inc. board.

---

## Article V: Finances

### Section 1: General Fund
All funds received through membership dues, fundraising, or donations shall be deposited into the **general fund** managed by **Do Something Amateur Radio Club, Inc.**. The DSARC, Inc. board shall approve and allocate budgets to DSARC based on submitted plans.

### Section 2: Earmarked Donations
Donations with a memo specifying a purpose shall be restricted to that purpose, in compliance with DSARC, Inc.’s financial policies.

### Section 3: Reporting
The DSARC Treasurer shall provide accurate financial reports to the club membership and submit them to the DSARC, Inc. board as required.

---

## Article VI: Meetings

### Section 1: Regular Meetings
DSARC shall hold regular monthly meetings for educational, technical, and club business purposes. Meeting details shall be communicated to all members at least 7 days in advance.

### Section 2: Quorum
A quorum for voting on club matters shall consist of **50% of voting members** present. If quorum is not achieved:
- The **DSARC, Inc. board** retains the authority to make decisions on behalf of the club to ensure operational continuity.
- Any decisions made by the board shall be communicated to the club membership at the next meeting and recorded in the minutes.

### Section 3: Voting
Only **dues-paying members** with valid amateur radio licenses may vote. Decisions require a simple majority of votes cast by members present.

---

## Article VII: Amendments

Amendments to this Constitution may be made by a **two-thirds majority vote** of voting members present at a regular meeting, provided that:
1. Notice of the proposed amendment is given to members at least 14 days in advance.
2. The amendment is submitted to the **DSARC, Inc. board** for final approval.

---

## Article VIII: Compliance

### Section 1: Oversight
DSARC shall operate in compliance with the bylaws, policies, and financial procedures established by **Do Something Amateur Radio Club, Inc.**.

### Section 2: Alignment
The club's activities, decisions, and leadership shall align with the mission and purpose of DSARC, Inc., as defined in its governing bylaws.

---
